// `contact.no_longer_recurring.v1` — emitted by contacts-db-backend's
// donor-status refresher (PE-1649) when a refresh transitions a contact OUT of
// being a recurring donor: they previously HELD a subscription (ACTIVE, or
// ERROR — failing but not canceled) and now hold none.
//
// IT IS A TRANSITION EVENT, NOT A STATE EVENT (same discipline as
// marketing.plan-changed.v1). The refresher emits it only on the
// holding→not-holding crossing, AFTER writing the refreshed donor fields to
// the contact row — which is also the dedup: an SQS redelivery re-runs the
// refresh against the already-updated row and the crossing condition is no
// longer true, so no duplicate emit. ACTIVE→ERROR (a failing card) does NOT
// emit — that donor never left; the failed-payment recovery flow owns that
// moment.
//
// Producer: contacts-db-backend (`Source: 'charitystack.contacts-db'`),
//   functions/donor_status_refresher/donor_status_refresher.py — best-effort
//   emit (NEVER raises; a PutEvents failure must not fail the refresh).
//   `organizationId` is the contact row's `merchantID`, which IS the CS org id
//   in the marketing domain (the same field the donation bridge's org-id
//   resolution relies on).
// Consumer: marketing-backend — the no-longer-recurring bridge (marketing
//   gate: non-marketing orgs dropped) → the `no-longer-recurring` Inngest
//   workflow → PF `/track` of the `contact.no_longer_recurring`
//   project-defined event (bare trigger, no revenue), which merchants' win-back
//   automations fire on.
// detailType in EventBridge: `contact.no_longer_recurring.v1` (Commitment 6).
//
// Status: active

import { z } from 'zod';

import { eventEnvelopeSchema } from './base.js';

export const contactNoLongerRecurringV1Schema = eventEnvelopeSchema.extend({
  // The contactsdb contact who stopped being a recurring donor. Marketing
  // resolves their pocketflow_customer_id from it; a contact that was never
  // synced to PF is a clean skip in the workflow.
  contactId: z.string().min(1).max(256),
});

export type ContactNoLongerRecurringV1 = z.infer<
  typeof contactNoLongerRecurringV1Schema
>;

export const CONTACT_NO_LONGER_RECURRING_V1_DETAIL_TYPE =
  'contact.no_longer_recurring.v1' as const;
